<template>
  <div>
    <div
      :class="'card-list ' + (!!card.isDisable ? 'card-disabled grey' : '')"
      v-for="(card, index) in extraInfoList"
      :key="index"
      @click="handleClick(card)"
    >
      <el-radio
        v-model="selectedMent"
        :label="isEqual2(selectedMent, card) ? selectedMent : card"
        position="right"
        :disabled="!!card.isDisable"
        :icon="card.card_org || card.cardOrg"
        :tip="card.disableReason"
        :message="card.tip"
        >{{ card.card_suffix || card.cardSuffix }}</el-radio
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { isEqual } from 'lodash-es';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      extraInfoList: ({ pay }) => pay.extraInfoList,
      selectedCard: ({ pay }) => pay.selectedCard,
      selectedMent: ({ pay }) => pay.selectedMent,
    }),
  },
  filters: {
    // 取卡号后4位
    cardFilter(card) {
      return String(card).slice(-4) || '';
    },
  },
  mounted() {
    this.setSelectedMent(this.selectedCard);
  },
  methods: {
    ...mapMutations('pay', ['setSelectedMent']),
    handleClick(card) {
      if (card && !card.isDisable) {
        this.setSelectedMent(card);
      }
    },
    isEqual2(a, b) {
      const aIndex = a?.cardIndex || a?.card_index;
      const bIndex = b?.cardIndex || b?.card_index;
      return aIndex === bIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-list {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
  padding: 20px 0;
}
</style>
<style lang="scss">
.card-list {
  width: 400px;
  .el-radio__position {
    width: 382px;
    img {
      border-radius: 2px;
    }
  }
  .el-radio__label {
    flex: 1;
    font-size: 16px;
    font-family: 'Aspira Medium';
    font-weight: 500;
  }
  .el-radio__message {
    font-size: 14px;
    font-family: 'Aspira Medium';
    font-weight: 500;
    position: relative;
    top: 1px;
  }
  .el-radio__icon {
    width: unset;
    height: 16px;
  }
  .el-radio__tip {
    font-family: 'Aspira Light';
    font-weight: 200;
    font-size: 14px;
    line-height: 15px;
    color: #999;
  }
}
.card-disabled {
  cursor: not-allowed;
  .el-radio__label {
    color: #999;
    cursor: not-allowed;
  }
}
@media screen and (max-width: 768px) {
  .card-list {
    width: rem(680);
    .el-radio__position {
      width: rem(650);
    }
    .el-radio__icon {
      width: rem(48);
    }
  }
}
</style>